<template>
	<HeadingX class="c-base-h2" v-bind="{ tag }" level-offset="1">
		<template v-if="domProps.textContent">
			{{ domProps.textContent }}
		</template>
		<template v-else>
			<slot></slot>
		</template>
	</HeadingX>
</template>

<script>
import HeadingX from '~/citi-baseline/components/HeadingX';

export default {
	name: 'BaseH2',
	components: { HeadingX },

	props: {
		tag: {
			type: String,
			default: undefined,
		},
	},

	computed: {
		domProps() {
			const { domProps } = this.$vnode?.data || {};
			return domProps || {};
		},
	},
};
</script>

<style>
.c-base-h2 {
	@apply text-h2 font-semibold;
}
</style>
